<template>
    <div class="flex">
        <a href="#" title="Search" class="text-base p-4 flex hover:text-yellow-300 text-white" @click.prevent="open()">
            <i class="fas fa-search"></i>
        </a>
        <slideover title="Search" name="search" class="relative" shortcut="S">
            <div class="my-0 -mx-3 fixed bg-white" style="width: 424px">
                <div class="mt-0 mb-4 mx-3">
                    <input
                        ref="searchbox"
                        type="text"
                        v-model="search"
                        class="m-0 relative rounded-md shadow-sm block w-full border sm:text-sm focus:outline-none focus:ring-brand focus:border-brand"
                        placeholder="Search"
                        :autofocus="true"/>
                    <div class="absolute right-6 top-2" v-if="searching">
                        <svg class="animate-spin h-5 w-5 text-brand mx-auto " xmlns="http://www.w3.org/2000/svg"
                             fill="none"
                             viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="mt-2 mb-5">&nbsp;</div>
            <div :key="refreshKey">
                <div v-if="!search">
                    <h2 class="text-xl font-medium text-gray-800 mb-1">Recent Packages</h2>
                    <search-header-widget-recents :no-headings="true" :loading="false" :results="recents"
                                                  :ignore-empty-state="true"></search-header-widget-recents>
                </div>
                <div v-else>
                    <search-header-widget-results :loading="searching" :ignore-empty-state="false"
                                                  :results="results"></search-header-widget-results>
                </div>
            </div>

        </slideover>
    </div>
</template>

<script>
import {Package} from '@models'
import UiButtonNew from "../ui/UiButtonNew";

export default {
    components: {
        UiButtonNew
    },
    props: {},
    filters: {
        truncate: function (text, stop, clamp) {
            return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
        }
    },
    data() {
        return {
            show: false,
            hidden: true,
            refreshKey: 1,
            search: "",
            searching: false,
            results: {},
            recents: {
                packages: []
            },
            searches: [],
            disabledOpening: false
        }
    },
    watch: {
        search: function () {
            if (this.search !== '') {
                this.searchDebounce();
            } else {
                if (this.searchRequest) {
                    this.searchRequest.forEach((i) => i.cancel());
                }
                this.searching = false
                this.results = {}
            }
        }
    },
    computed: {},
    methods: {
        async doSearch() {
            this.searching = true
            if (this.searchRequest) {
                this.searchRequest.forEach((i) => i.cancel());
            }
            this.searchRequest = [axios.CancelToken.source(), axios.CancelToken.source()]
            let searches = [
                axios.get(route('api.v1.search.legacy'), {
                    cancelToken: this.searchRequest[0].token,
                    params: {query: this.search}
                }).catch(function (err) {
                    if (axios.isCancel(err)) {
                        // OK - is a cancelled request
                    }
                }),
            ]
            await Promise.all(searches).then((a) => {
                if (a[0]) {
                    this.results = a[0].data
                    this.searching = false
                }
            }).catch(function (err) {
            })

        },
        searchDebounce: _.debounce(function () {
            this.doSearch();
        }, 100),
        async setRecents() {
            this.recents.packages = await Package.recent()
            this.forceRefresh()
        },
        forceRefresh() {
            this.refreshKey = this.refreshKey + 1
        },
        close() {
            eventBus.$emit('slideover-close-search')
            this.hidden = true;
        },
        open() {
            window.Bus.emit('close-all-slideovers');
            let that = this
            eventBus.$emit('slideover-open-search')
            this.setRecents()
            this.focus()
            this.hidden = false;
        },
        focus() {
            if (this.$refs.searchbox) {
                this.$refs.searchbox.focus()
            } else {
                setTimeout(() => this.focus(), 100);
            }
        }
    },
    mounted() {
        this.setRecents()

        window.Bus.on('close-all-slideovers', () => {
            this.close()
        })

        window.Bus.on('show-package-filesystem', () => {
            this.close()
            this.disabledOpening = true;
        });

        window.Bus.on('close-package-filesystem', () => {
            this.disabledOpening = false;
        });

        window.addEventListener('keydown', (e) => {
            if (e.ctrlKey || e.metaKey) {
                return;
            }
            if (e.keyCode === 27) {
                this.close()
                return
            }
            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(e.target.tagName)) {
                return;
            }
            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(document.activeElement.tagName)) {
                return;
            }

            if (!this.disabledOpening) {
                if ((e.key === 's') || (e.key === 'S')) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.hidden) {
                        this.open()
                    } else {
                        this.close()
                    }
                }
            }
        })

    }
}
</script>